"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMessageEnum = void 0;
var AuthMessageEnum;
(function (AuthMessageEnum) {
    AuthMessageEnum["WEAK_PASSWORD"] = "Weak Password";
    AuthMessageEnum["INVALID_PWD_RESET_CODE"] = "Invalid Code";
    AuthMessageEnum["INVALID_CREDENTIAL"] = "Invalid Email or Password";
    AuthMessageEnum["PENDING_VERIFICATION"] = "Pending Verification";
    AuthMessageEnum["PENDING_CHANGE_PASSWORD"] = "Pending Password Change";
    AuthMessageEnum["MISSING_PARAMETER"] = "Missing mandatory parameters";
    AuthMessageEnum["LOCKED"] = "3 unsuccessful login attempts.Your Account is Locked.Reset Password using Forgot Password link.";
    AuthMessageEnum["USER_NOT_LOGGEDIN"] = "User is not logged in";
    AuthMessageEnum["DEACTIVATED"] = "User has been deactivated";
    AuthMessageEnum["INVALID_PHONE_NUMBER_FORMAT"] = "Invalid Phone Number Format";
    AuthMessageEnum["INVALID_EMAIL_FORMAT"] = "Invalid Email Address Format";
    AuthMessageEnum["USER_ALREADY_EXISTS"] = "User Already Exists";
})(AuthMessageEnum = exports.AuthMessageEnum || (exports.AuthMessageEnum = {}));
//# sourceMappingURL=auth.message.js.map